import api from './api';

export const serviceService = {
  // Dohvati sve usluge
  getAllServices: async () => {
    return await api.get('/services?limit=1000');
  },

  // Dohvati uslugu po ID-u
  getServiceById: async (id) => {
    return await api.get(`/services/${id}`);
  },

  // Kreiraj novu uslugu
  createService: async (serviceData) => {
    return await api.post('/services', serviceData);
  },

  // Ažuriraj uslugu
  updateService: async (id, serviceData) => {
    return await api.put(`/services/${id}`, serviceData);
  },

  // Obriši uslugu
  deleteService: async (id) => {
    return await api.delete(`/services/${id}`);
  },

  // Dohvati usluge po tenant-u
  getServicesByTenant: async (tenantId, page = 1, limit = 10) => {
    return await api.get(`/services/tenant/${tenantId}?page=${page}&limit=${limit}`);
  },

  // Dohvati usluge po kategoriji
  getServicesByCategory: async (category) => {
    return await api.get(`/services/category/${category}`);
  },

  // Dohvati dostupne usluge za online booking
  getAvailableOnlineServices: async () => {
    return await api.get('/services/available/online');
  },

  // Dohvati kategorije
  getServiceCategories: async () => {
    return await api.get('/services/categories/list');
  },

  // Dohvati statistiku
  getServiceStats: async () => {
    return await api.get('/services/stats/overview');
  },
};

export default serviceService;
